import { AxiosInstance } from "axios";
import * as requestUrl from "../../constants/request";
import { FetchAccountSummaryResult } from "./accountSummary-state";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { FilterProps } from "store/common";

const constructStatementsUrl = (
  {
    minDate,
    maxDate,
    searchKeyword,
    dueDate,
    pastDue,
    autoPay,
    pageNumber,
    pageSize,
    sortColumn,
    sortDir,
  }: Partial<FilterProps>,
  statementsUrl: URL
): URL => {
  if (!!minDate) {
    statementsUrl.searchParams.append("minDate", minDate);
  }
  if (!!maxDate) {
    statementsUrl.searchParams.append("MaxDate", maxDate);
  }
  if (!!searchKeyword) {
    statementsUrl.searchParams.append("searchKeyword", searchKeyword);
  }
  if (dueDate !== undefined && dueDate !== null) {
    statementsUrl.searchParams.append("dueDate", dueDate.toString());
  }
  if (pastDue !== undefined && pastDue !== null) {
    statementsUrl.searchParams.append("pastDate", pastDue.toString());
  }
  if (autoPay !== undefined && autoPay !== null) {
    statementsUrl.searchParams.append("autoPay", autoPay.toString());
  }
  if (pageSize !== undefined && pageSize !== null) {
    statementsUrl.searchParams.append("PageSize", pageSize.toString());
  } else {
    statementsUrl.searchParams.append("PageSize", "10");
  }
  if (pageNumber !== undefined && pageNumber !== null) {
    statementsUrl.searchParams.append("PageNum", pageNumber.toString());
  } else {
    statementsUrl.searchParams.append("PageNum", "1");
  }
  if (sortColumn !== undefined && sortColumn !== null) {
    statementsUrl.searchParams.append("SortColumn", sortColumn.toString());
  }
  if (sortDir !== undefined && sortDir !== null) {
    statementsUrl.searchParams.append("SortDir", sortDir.toString());
  }
  return statementsUrl;
};

export type FetchAccountSummary = typeof fetchAccountSummary;

export const fetchAccountSummary = createAsyncThunk<
  FetchAccountSummaryResult,
  {
    request: AxiosInstance;
    data: FilterProps;
  }
>("accountsummary/fetchAccountSummary", async ({ request, data }) => {
  let accountSummaryUrl = new URL(
    requestUrl.FT_PAYMENT_ACTIVITY + "jhjh",
    requestUrl.FT_REQUEST_BASE_URL
  );

  accountSummaryUrl = constructStatementsUrl(data, accountSummaryUrl);

  const paData = await request(accountSummaryUrl.toString());
  return paData.data;
});
